/*
 * @Author: edvardchen
 * @Date:   2016-11-12 12:05:39
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-07 17:34:43
 */

import React from 'react';
import PropTypes from 'prop-types';
import autobind from 'core-decorators/lib/autobind';
import _ from 'lodash';

import * as urlHelper from '@tencent/qb-article-util/lib/urlHelper';

import Article from '../Article';
import contextTypes from './contextTypes';

import { reportArticlePV } from '../../fetchers';
import { isomorphicConfig, track } from '../../utility';
import { loadDownloadScene } from '../../actions/sharepage';
import { refreshRMP } from '../../utility/ClipperForRMP';

import { getProfileId } from '../../utility/PageConfigDataForShare';

let reportToShareCenter;
if (__CLIENT__) {
  reportToShareCenter = require('../../utility/reportToShareCenter').default;
  require('./ArticleContainer.scss');
}

const getVideoDBLinkText = (QBInstalled) => {
  const name = QBInstalled ? 'relive' : 'renew';
  return _.get(isomorphicConfig, `share.article.video.tip.${name}`);
};

class ArticleContainer extends React.PureComponent {
  static propTypes = {
    article: PropTypes.shape(Article.propTypes),
    variables: PropTypes.object,
    QBInstalled: PropTypes.bool,
    exposureSharelp: PropTypes.object,
    isShareUser: PropTypes.bool,
    dispatch: PropTypes.func,
  };

  static contextTypes = contextTypes;

  constructor(props) {
    super(props);
    this.state = {
      collapseScreen: Number(_.get(isomorphicConfig, 'share.article.collapseScreen')) || 0,
      share: true,
      videoDBLinkText: getVideoDBLinkText(props.QBInstalled),
    };
  }

  componentDidMount() {
    const { article, variables } = this.props;
    const { ch, extenddata } = variables;
    reportToShareCenter('visit');
    const { docId, url } = article;
    this.context.onShare({
      sTitle: article.title,
      sSummary: article.abstract,
      sPicUrl: article.thumbs[0],
      openUrl: urlHelper.buildArticleQBUrl({
        docId,
        ch,
        url,
        business: 'coolread',
      }),
    });
    reportArticlePV(
      Object.assign(
        {
          ch,
          extenddata,
        },
        article,
      ),
    );
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      videoDBLinkText: getVideoDBLinkText(nextProps.QBInstalled),
    });
  }

  @autobind
  onClickVideoDBLink() {
    this.context.downloadOrOpenQb({
      url: _.get(isomorphicConfig, 'share.bottomVideo.url'),
      label: 'video_in_article',
    });
  }
  @autobind
  onClickReadAll() {
    this.props.dispatch(loadDownloadScene('article')); // 点击推荐文章底部按钮，标志来源：正文底部按钮
    refreshRMP(this.props.exposureSharelp && this.props.exposureSharelp.docId); // 点击推荐文章底部按钮，写入剪切板
    this.context.downloadOrOpenQb({
      url: window.location.href,
      label: 'article_readAll',
      hideMaskModal: true,
    });

    track({
      location: 'sharelp',
      action: 'click',
      object: 'sharelp_seemorebten',
      id: this.props.exposureSharelp && this.props.exposureSharelp.docId,
      ch: getProfileId() || (this.props.exposureSharelp && this.props.exposureSharelp.ch),
    });
  }

  @autobind
  onClickArticleImageBtn() {
    this.props.dispatch(loadDownloadScene('article')); // 点击推荐文章底部按钮，标志来源：正文底部按钮
    refreshRMP(this.props.exposureSharelp && this.props.exposureSharelp.docId); // 点击推荐文章底部按钮，写入剪切板
    this.context.downloadOrOpenQb({
      url: window.location.href,
      label: 'article_readAll',
      hideMaskModal: true,
    });

    track({
      location: 'sharelp',
      action: 'click',
      object: 'sharelp_article_imagebtn',
      id: this.props.exposureSharelp && this.props.exposureSharelp.docId,
      ch: getProfileId() || (this.props.exposureSharelp && this.props.exposureSharelp.ch),
    });
  }

  render() {
    const { article, variables, isShareUser } = this.props;
    return (
      <Article
        {...article}
        {...this.state}
        ch={variables.ch}
        sourceLinkText={''}
        onClickVideoDBLink={this.onClickVideoDBLink}
        onClickReadAll={this.onClickReadAll}
        onClickArticleImageBtn={this.onClickArticleImageBtn}
        isShareUser={isShareUser}
      />
    );
  }
}

export default ArticleContainer;
